import { ICreateItem, IRequestForMovementCreateItemModal, IValidatorCreatorModal} from "../../interfaces"
import { DateTime } from "luxon"
import { FC, useEffect, useState } from "react"
import { v4 as uuidv4 } from "uuid"
import { useTranslation } from "react-i18next";
import { IdTableVariant } from "../../../../../@types/enumsGlobal"
import GridSelectorInput from "../../../../../components/controls/GridSelectorInput"
import GridWrapper from "../../../../../components/controls/GridWrapper"
import { NumberInput, TextInput } from "../../../../../components/controls/inputs"
import { BaseModalWindow } from "../../../../../components/modalWindows/BaseModalWindow"
import modalStyles from "../../../../../components/modalWindows/styles/BaseModalWindow.module.scss"
import { IEntitySimpleDTO } from "../../../../../libs/coreapi-dto/@types/common"
import { ISubstanceViewDTO } from "../../../../../libs/coreapi-dto/dirs/substance"
import { ITradeNameViewDTO } from "../../../../../libs/coreapi-dto/dirs/tradeName"
import { IRequestForMovementItemDTO } from "../../../../../libs/coreapi-dto/documents/requestForMovementItem"
import { SubstanceDataProvider } from "../../../../../Services/DataProviders/SubstanceDataProvider"
import { TradeNameDataProvider } from "../../../../../Services/DataProviders/TradeNameDataProvider"
import { useForm } from "../../../../../system/hooks/useForm"
import { useAppContext } from "../../../../../system/providers/appContextProvider"
import createRequestForMovementStyles from "../styles/CreateRequestForMovement.module.scss"
import { GoodsDataProvider } from "../../../../../Services/DataProviders/GoodsDataProvider"
import { GoodsSelectorModal } from "../../../../Dictionaries/Goods"
import { CureFormDataProvider } from "../../../../../Services/DataProviders/CureFormDataProvider"
import { ICureFormViewDTO } from "../../../../../libs/coreapi-dto/dirs/cureform"
import { LotDataProvider } from "../../../../../Services/DataProviders/LotDataProvider"
import useGridFilter, { CreateSelectorGridFilter } from "../../../../../system/hooks/useGridFilter"
import SubstanceByStoreSelectorModal from "../../../../Dictionaries/Substance/SubstanceByStoreSelectorModal";
import TradeNameByStoreSelectorModal from "../../../../Dictionaries/TradeName/TradeNameByStoreSelectorModal";
import DosageByStoreSelectorModal from "../../ByStoreComponents/DosageByStoreSelectorModal";
import CureFormByStoreSelectorModal from "../../ByStoreComponents/CureFormByStoreSelectorModal";
import NFvByStoreSelectorModal from "../../ByStoreComponents/NFvByStoreSelectorModal";
import { RequestForMovementDataProvider } from "../../../../../Services/DataProviders/RequestForMovementDataProvider";

export const RequestForMovementCreatorItemModal: FC<IRequestForMovementCreateItemModal> = (props) => {
    const appCtx = useAppContext()
    const tradeNameDP = new TradeNameDataProvider(appCtx.coreApiService)
    const substanceDP = new SubstanceDataProvider(appCtx.coreApiService)
    const goodsDP = new GoodsDataProvider(appCtx.coreApiService)
    const requestForMovementDP = new RequestForMovementDataProvider(appCtx.coreApiService)
       
    const [substanceNameRus, setSubstanceNameRus] = useState<IEntitySimpleDTO | undefined>(undefined)
    const [substanceNameLat, setSubstanceNameLat] = useState<IEntitySimpleDTO | undefined>(undefined)
    const [tradeNameRus, setTradeNameRus] = useState<IEntitySimpleDTO | undefined>(undefined)
    const [cureForm, setCureForm] = useState<IEntitySimpleDTO | undefined>(undefined)
    const [nFVvalue, setNFVValue] = useState<IEntitySimpleDTO | undefined>(undefined)
    const [dosageValue, setDosageValue] = useState<IEntitySimpleDTO | undefined>(undefined)

    const [substanceItem, setSubstanceItem] = useState<ISubstanceViewDTO>({} as ISubstanceViewDTO)
    const [tradeNameItem, setTradeNameItem] = useState<ITradeNameViewDTO>({} as ITradeNameViewDTO)
    const [cureFormItem, setCureFormItem] = useState<ICureFormViewDTO>({} as ICureFormViewDTO)
    
    const [quantity, setQuantity] = useState<number>(1)
    const [nFv, setNFV] = useState<string>()
    const [dosage, setDosage] = useState<string>()

    const [createItem, setCreateItem] = useState<IRequestForMovementItemDTO>({} as IRequestForMovementItemDTO)
    const [idGlobal, setIdGlobal] = useState<string>(props.idDocumentItemGlobal ?? uuidv4())

    const [idStoreSupplier, setIdStoreSupplier] = useState(props.idSupplierStoreExternalGlobal)
    const [remains, setRemains] = useState(0)
    
    const [searchFilter, dispatchSearchFilter] = useGridFilter(CreateSelectorGridFilter);
    const searchOption: "substanceName" | "tradeName" = props.tradeName?.idGlobal ? "tradeName" : "substanceName";
    const isQuantityControl = props.isQuantityControl
    const isQuantityControlVisible = props.isQuantityControlVisible
    const [filter, setFilter] = useState<IDistinctByStoreFilterData>({})

    const { t } = useTranslation();
    const errorsT = (value: string) => t('errors.' + value);

    useEffect(() => {
        const fetchData = async () => {
            try {
                let initFilter = {} as IDistinctByStoreFilterData

                if (props.substance?.idGlobal) {
                    substanceDP.getById(props.substance.idGlobal, (e) => {
                        setSubstanceItem(e as ISubstanceViewDTO)
                        initFilter = {
                            goodsName: e.name,
                            idStoreGlobal: props.idSupplierStoreExternalGlobal,
                        }
                        setFilter(initFilter)
                        requestForMovementDP.remains(initFilter, (e) => {
                            setRemains(e as number)
                        })
                    })
                }
                if (props.tradeName?.idGlobal) {
                    tradeNameDP.getById(props.tradeName.idGlobal, (e) => {
                        setTradeNameItem(e as ITradeNameViewDTO)
                        initFilter = {
                            goodsName: e.nameRus,
                            idStoreGlobal: props.idSupplierStoreExternalGlobal,
                        }
                        setFilter(initFilter)
                        requestForMovementDP.remains(initFilter, (e) => {
                            setRemains(e as number)
                        })
                        goodsDP.getView({
                            pageNumber: 1,
                            numberPerPage: 1,
                            columnFilters: [
                                {
                                    name: "TradeName",
                                    operator: 'Eq',
                                    value: e.nameRus
                                }
                            ],
                        }, (data) => {
                            if (data[0].substanceName) {
                                substanceDP.getView({
                                    pageNumber: 1,
                                    numberPerPage: 1,
                                    columnFilters: [
                                        {
                                            name: "Name",
                                            operator: 'Eq',
                                            value: data[0].substanceName
                                        }
                                    ],
                                }, (substance) => {
                                    if (substance) {
                                        setSubstanceItem(substance[0] as ISubstanceViewDTO)
                                    }
                                })
                            }
                        })
                    })
                }
            } catch (error) {
                console.error("Ошибка при получении данных:", error)
            }
        }
        fetchData()
    }, [props])

    useEffect(() => {
        if (substanceItem.name) {
            setSubstanceNameRus({
                idGlobal: substanceItem.idGlobal,
                displayName: substanceItem.name,
            })
        }
        if (substanceItem.nameLat) {
            setSubstanceNameLat({
                idGlobal: substanceItem.idGlobal,
                displayName: substanceItem.nameLat,
            })
        }
        if (tradeNameItem.nameRus) {
            setTradeNameRus({
                idGlobal: tradeNameItem.idGlobal,
                displayName: tradeNameItem.nameRus,
            })
        }
        if (cureFormItem.idGlobal) {
            setCureForm({
                idGlobal: cureFormItem.idGlobal,
                displayName: cureFormItem.name
            })
        }
        if (nFv) {
            setNFVValue({
                idGlobal: uuidv4(),
                displayName: nFv.toString()
            })
        }
        if (dosage) {
            setDosageValue({
                idGlobal: uuidv4(),
                displayName: dosage
            })
        }
    }, [substanceItem, tradeNameItem, cureFormItem, nFv, dosage])

    useEffect(() => {
        const newFilter = {
            idStoreGlobal: idStoreSupplier,
            goodsName: tradeNameItem.nameRus || substanceItem.name,
            cureForm: cureForm?.idGlobal,
            dosage: dosage,
            nFv: nFv,
        };

        if (newFilter.goodsName && newFilter.idStoreGlobal) {
            setFilter(newFilter);
            requestForMovementDP.remains(newFilter, (e) => {
            setRemains(e as number);
            });
        }
    }, [substanceItem, tradeNameItem, cureFormItem, nFv, dosage, idStoreSupplier]);

    useEffect(() => {
        if(props.idSupplierStoreExternalGlobal) {
            setIdStoreSupplier(props.idSupplierStoreExternalGlobal)
        }
    }, [props])

    useEffect(() => {
        if (isQuantityControl && remains >= 0 && quantity > remains) {
            const newQuantity = Math.max(remains, 0)
            setQuantity(newQuantity)
            setCreateItem((prev) => ({
                ...prev,
                quantity: newQuantity,
            }))
        }
    }, [remains, props.isQuantityControl])

    useEffect(() => {
        setCreateItem({
            idGlobal: uuidv4(),
            dateCreated: DateTime.now(),
            idSubstanceExternalGlobal: substanceNameLat?.idGlobal ?? "",
            idTradeNameExternalGlobal: tradeNameRus?.idGlobal ?? "",
            idCureFormExternalGlobal: cureForm?.idGlobal ?? "",
            dosage: dosageValue?.displayName,
            nFv: nFv ?? "",
            quantity: quantity,
            supplierCostInfo: {
                vat: 0,
                price: 0,
                vatPrice: 0,
                priceIncVat: 0,
                sum: 0,
                vatSum: 0,
                sumIncVat: 0,
                adprice: 0,
            },
            retailCostInfo: {
                vat: 0,
                price: 0,
                vatPrice: 0,
                priceIncVat: 0,
                sum: 0,
                vatSum: 0,
                sumIncVat: 0,
                adprice: 0,
            },
        } as IRequestForMovementItemDTO)
    }, [])
        
    const onQuantityChange = (value: number) => {
        setQuantity(value)
        setCreateItem((prev) => ({
            ...prev,
            quantity: value,
        }))
    }

    const onOk = () => {
        const newCreateItem: ICreateItem = {
            item: {
                ...createItem,
                dateCreated: DateTime.now(),
                nFv: nFv as string ?? "",
                idCureFormExternalGlobal: cureFormItem.idGlobal,
                quantity: quantity,
                dosage: dosageValue?.displayName as string,
                idSubstanceExternalGlobal: substanceItem.idGlobal ?? '',
                idTradeNameExternalGlobal: tradeNameItem.idGlobal ?? '',
                
                supplierCostInfo: {
                    vat: 0,
                    price: 0,
                    vatPrice: 0,
                    priceIncVat: 0,
                    sum: 0,
                    vatSum: 0,
                    sumIncVat: 0,
                    adprice: 0,
                },
                retailCostInfo: {
                    vat: 0,
                    price: 0,
                    vatPrice: 0,
                    priceIncVat: 0,
                    sum: 0,
                    vatSum: 0,
                    sumIncVat: 0,
                    adprice: 0,
                },
            },
            displayItem: {
                idGlobal: createItem.idGlobal,
                substanceNameLat: substanceItem.nameLat,
                substanceName: substanceItem.name,
                tradeName: tradeNameItem.nameRus,
                quantity: createItem.quantity,
                dateCreated: DateTime.now(),
                dosage: dosage,
                nFv: nFv as string ?? "",
                cureFormName: cureFormItem.name,
            },
            filter: {
                idItem: createItem.idGlobal,
                quantityMin: 1,
                quantityMax: remains,
            },
        }
        props.ok(newCreateItem)
    }

    const { isValid, errors, setErrors } = useForm<IValidatorCreatorModal>({
        validations: {
            quantity: {
                custom: {
                    isValid: () => remains > 0,
                    message: errorsT("requestQuantity")
                },
            },
            remains: {
                custom: {
                    isValid: () => remains >= quantity,
                    message: errorsT("remains")
                },
            },
        },
    })
    
    useEffect(() => {
        if (searchOption === "substanceName") {
            dispatchSearchFilter({
                type: 'paramSimpleFilter',
                payload: {                    
                    gridParamFilter: {
                        goodsName: substanceItem.name,
                        idStoreGlobal: props.isGetFromStore ? idStoreSupplier : null,
                        cureForm: props.isGetFromStore ? cureForm?.idGlobal : null,
                        dosage: props.isGetFromStore ? dosage : null,
                        nFv: props.isGetFromStore ? nFv : null,
                    },
                    gridColumnFilter: [
                        {
                            name: "deleted",
                            operator: "Eq",
                            value: false,
                        },
                    ],                    
                },
            })

        }
        if (searchOption === "tradeName") {
            dispatchSearchFilter({
                type: 'paramSimpleFilter',
                payload: {
                    gridParamFilter: {
                        goodsName: tradeNameItem.nameRus,
                        idStoreGlobal: props.isGetFromStore ? idStoreSupplier : null,
                        cureForm: props.isGetFromStore ? cureForm?.idGlobal : null,
                        dosage: props.isGetFromStore ? dosage : null,
                        nFv: props.isGetFromStore ? nFv : null,
                    },
                    gridColumnFilter: [
                        {
                            name: "deleted",
                            operator: "Eq",
                            value: false,
                        },
                    ],
                    
                },
            })
        }    
    }, [substanceItem?.idGlobal, tradeNameItem.idGlobal, idStoreSupplier, searchOption, cureForm?.idGlobal, dosage, nFv])

    return (
        <BaseModalWindow
            header={"Создание позиции заявки: " + (tradeNameItem?.idGlobal ? "ТН" : "МНН")}
            ok={{
                onClick: () => {
                    if (!isQuantityControl) {
                        onOk();
                    }
                    if (isValid()) {
                        onOk()
                    }
                },
            }}
            cancel={{ onClick: props.cancel }}
            modalWindowClassName={modalStyles.modalWindowRequestForMovement}
            footerStyle="confirm"
        >
            <GridSelectorInput
                disabled={props.tradeName?.idGlobal !== undefined} //Если строка "ТН" заполнена и данная строка пустая, то она должна быть нередактируемой
                required
                selectedEntity={substanceNameRus}                
                selectorModalJsx={SubstanceByStoreSelectorModal}
                className={createRequestForMovementStyles.field_DocumentBase}
                id={"inputAccompanyingSelectionGoods"}
                inline={false}
                label={"МНН (рус.)"}
                searchOption={"substanceName"}
                value={substanceItem.name ?? ""}
                idTable={IdTableVariant.RequestForMovement}
                onClear={() => {
                    setSubstanceNameRus(undefined)
                    setSubstanceItem({} as ISubstanceViewDTO)                   

                    setCureForm(undefined)
                    setCureFormItem({} as ICureFormViewDTO)

                    setNFV(undefined)
                    setNFVValue({} as IEntitySimpleDTO)

                    setDosage(undefined)
                    setDosageValue({} as ICureFormViewDTO)
                                        
                    setRemains(0)
                }}               
                onSelect={(value) => {
                    goodsDP.getById(value.idGlobal, (goods) => {                        
                        substanceDP.getById(goods.substance?.idGlobal, (substance) => {
                            setSubstanceItem(substance as ISubstanceViewDTO)
                            let initFilter = {
                                ...filter,
                                goodsName: substance.name
                            }
                            setFilter(initFilter)
                            requestForMovementDP.remains(initFilter, (e) => {
                                setRemains(e as number)
                            })
                        })
                    })
                }}
                idStoreSupplier={props.isGetFromStore ? idStoreSupplier : undefined}
                getUniqueGoodsByStore={props.isGetFromStore}
            />
            <TextInput
                disabled={true}
                className={createRequestForMovementStyles.field_DocumentBase}
                label={"МНН (лат.)"}
                value={substanceNameLat?.displayName ?? ""}
            />

            <GridSelectorInput
                disabled={!props.tradeName?.idGlobal} //1.	Если строка "МНН (лат.)" заполнена и данная строка пустая, то она должна быть нередактируемой
                required                
                selectorModalJsx={TradeNameByStoreSelectorModal}
                className={createRequestForMovementStyles.field_DocumentBase}
                id={"inputAccompanyingSelectionGoods"}
                inline={false}
                label={"ТН"}
                searchOption={"tradeName"}
                value={tradeNameItem.nameRus ?? ""}
                idTable={IdTableVariant.RequestForMovement}
                selectedEntity={tradeNameRus}
                onClear={() => {
                    setTradeNameRus(undefined)
                    setTradeNameItem({} as ITradeNameViewDTO)

                    setSubstanceNameLat(undefined)
                    setSubstanceItem({} as ISubstanceViewDTO)

                    setCureForm(undefined)
                    setCureFormItem({} as ICureFormViewDTO)

                    setNFV(undefined)
                    setNFVValue({} as IEntitySimpleDTO)

                    setDosage(undefined)
                    setDosageValue({} as ICureFormViewDTO)

                    setRemains(0)
                }}
                onSelect={(value) => {
                    goodsDP.getById(value.idGlobal, (goods) => {
                        tradeNameDP.getById(goods.tradeName.idGlobal, (tradeName) => {
                            setTradeNameItem(tradeName as ITradeNameViewDTO)
                            let initFilter = {
                                ...filter,
                                goodsName: tradeName.nameRus
                            }
                            setFilter(initFilter)
                            requestForMovementDP.remains(initFilter, (e) => {
                                setRemains(e as number)
                            })
                        })
                    })
                }}
                idStoreSupplier={props.isGetFromStore ? idStoreSupplier : undefined}
                getUniqueGoodsByStore={props.isGetFromStore}
            />
            <GridWrapper cols={3}>
                <GridSelectorInput
                    disabled={!tradeNameItem?.idGlobal && !substanceNameLat?.idGlobal && !substanceNameRus?.idGlobal}
                    gridFilter={searchFilter}                    
                    searchOption={"cureFormName"}
                    selectorModalJsx={CureFormByStoreSelectorModal}                    
                    inline={false}
                    label={"Лекарственная форма"}                    
                    value={cureForm?.displayName ?? ''}
                    idTable={IdTableVariant.RequestForMovement}
                    selectedEntity={cureForm}
                    onClear={() => {
                        setCureForm(undefined)
                        setCureFormItem({} as ICureFormViewDTO)}
                    }
                    onSelect={(value) => {
                        const selectedCureForm = {
                            idGlobal: value?.idGlobal,
                            displayName: value?.displayName ?? ''
                        };        
                        setCureForm(selectedCureForm);
                        setCureFormItem({
                            ...value,
                            name: value.displayName ?? ''
                        } as ICureFormViewDTO);
                        let initFilter = {
                            ...filter,
                            cureForm: value.idGlobal
                        }
                        setFilter(initFilter)
                        requestForMovementDP.remains(initFilter, (e) => {
                            setRemains(e as number)
                        })
                    }}
                    idStoreSupplier={props.isGetFromStore ? idStoreSupplier : undefined}
                    getUniqueGoodsByStore={props.isGetFromStore}
                />                
              
                <GridSelectorInput
                    disabled={!tradeNameItem?.idGlobal && !substanceNameLat?.idGlobal && !substanceNameRus?.idGlobal}
                    gridFilter={searchFilter}
                    searchOption={"n_fv"}
                    selectorModalJsx={NFvByStoreSelectorModal}                    
                    inline={false}
                    label={"Фасовка"}                    
                    value={nFv ? nFv.toString() : undefined}
                    idTable={IdTableVariant.RequestForMovement}
                    selectedEntity={nFVvalue}
                    onClear={() => {
                        setNFV('')
                        setNFVValue({} as IEntitySimpleDTO)
                        }
                    }
                    onSelect={(value) => {
                        const selectedNFv = {
                            idGlobal: value?.idGlobal,
                            displayName: value.displayName ?? ''
                        };        
                        setNFVValue(selectedNFv);
                        setNFV('')
                        setNFV(value.displayName ?? '')
                        let initFilter = {
                            ...filter,
                            nFv: value.displayName
                        }
                        setFilter(initFilter)
                        requestForMovementDP.remains(initFilter, (e) => {
                            setRemains(e as number)
                        })
                    }}
                    idStoreSupplier={props.isGetFromStore ? idStoreSupplier : undefined}
                    getUniqueGoodsByStore={props.isGetFromStore}
                />

                <GridSelectorInput
                    disabled={!tradeNameItem?.idGlobal && !substanceNameLat?.idGlobal && !substanceNameRus?.idGlobal}
                    gridFilter={searchFilter}
                    searchOption={"dosage"}
                    selectorModalJsx={DosageByStoreSelectorModal}                    
                    inline={false}
                    label={"Дозировка"}                    
                    value={dosage ?? ''}
                    idTable={IdTableVariant.RequestForMovement}
                    selectedEntity={dosageValue}
                    onClear={() => {
                        setDosage('')
                        setDosageValue({} as IEntitySimpleDTO)}
                    }
                    onSelect={(value) => {
                        const selectedDosage = {
                            idGlobal: value?.idGlobal,
                            displayName: value.displayName ?? ''
                        };        
                        setDosageValue(selectedDosage);
                        setDosage('')
                        setDosage(value.displayName ?? '')
                        let initFilter = {
                            ...filter,
                            dosage: value.displayName
                        }
                        setFilter(initFilter)
                        requestForMovementDP.remains(initFilter, (e) => {
                            setRemains(e as number)
                        })
                    }}
                    idStoreSupplier={props.isGetFromStore ? idStoreSupplier : undefined}
                    getUniqueGoodsByStore={props.isGetFromStore}
                />
                
            </GridWrapper>            
                <GridWrapper cols={3}>
                    { isQuantityControlVisible &&
                        <NumberInput label="Доступно для перемещения" value={remains} disabled error={errors.remains}/>
                    }
                    <NumberInput                        
                        required
                        onFocus={() => setErrors({ ...errors, quantity: undefined })}
                        error={isQuantityControl ? errors.quantity : undefined}
                        keyBan={true}
                        label="Количество"
                        value={createItem.quantity}
                        onChange={(value) => onQuantityChange(value)}
                        min={1}
                        max={isQuantityControl ? remains : undefined}
                    />
                </GridWrapper>            
        </BaseModalWindow>
    )
}